export const RECURRING_BOOKING_QUERY_KEY = 'recurringBookingQueryKey'
